<template>
  <div class="input-wrap">
    <label for=""
      >{{ label }}
      <span class="asterisk" v-if="required">必須</span>
    </label>

    <v-date-picker v-model="dateValue">
      <span
        slot="header-title"
        slot-scope="{ year, month }"
        class="text-primary"
        style="text-decoration: underline"
      >
        {{ `${year}年${month}月` }}
      </span>
      <template v-slot="{ inputValue, togglePopover }">
        <div class="input-content">
          <input
            class="input"
            :value="inputValue"
            placeholder="年月日"
            readonly
            style="font-size: 14px"
          />
          <button
            style="width: 40px; padding: 4px 10px !important"
            @click="togglePopover({ placement: 'auto-start' })"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              class="w-4 h-4 fill-current"
            >
              <path
                d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z"
              ></path>
            </svg>
          </button>
          <span class="side-text">{{ sideText }}</span>
        </div>
      </template>
    </v-date-picker>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dateValue: '',
    }
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    setKey: {
      type: String,
      required: true,
    },
    sideText: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.date, this.setKey)
      if (this.date == '') return
      const array = this.date.split('-')
      const year = array[0]
      const month = array[1] - 1
      const day = array[2]
      this.dateValue = new Date(year, month, day)
    })
  },
  methods: {
    handleChangeInputValue() {
      this.$emit('input-value', this.dateValue, this.setKey)
    },
    togglePopover() {
      console.log('e')
    },
  },
  watch: {
    dateValue() {
      this.handleChangeInputValue()
    },
  },
}
</script>

<style lang="scss" scoped>
.input {
  margin: 0 auto;
  width: 100%;
  border: 1px solid #d8dbe0;
  border-radius: 5px;
  text-align: start;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
}
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.input {
  &-content {
    position: relative;
    height: 36px;
    z-index: 10000;
    .input {
      position: absolute;
      top: 0;
      left: 0;
    }
    button {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      border: 0;
      background: none;
      &:focus {
        outline: none;
      }
    }
  }
}
.asterisk {
  position: relative;
  padding-left: 20px;
  color: #ea5550;
  font-size: 12px;
  font-weight: bold;
  &::before {
    content: '※';
    position: absolute;
    top: calc(50% - 2px);
    left: 9px;
    transform: translateY(-50%);
  }
}

.side-text {
  position: absolute;
  top: -10px;
  right: -5px;
  transform: translate(100%, 100%);
}

::v-deep .vc-popover-content-wrapper {
  z-index: 10000 !important;
}
</style>
